export const TH = 'px-3 py-2.5 text-[11px] font-semibold uppercase tracking-wide text-slate-700 dark:text-slate-300';
export const TD = 'px-3 py-2.5 text-sm text-slate-700 dark:text-slate-200';
export const PANEL = 'rounded-2xl border border-slate-200 bg-white shadow-sm dark:border-slate-700 dark:bg-slate-800/70';
export const SECTION_TITLE = 'text-sm font-semibold text-slate-700 dark:text-slate-200';
export const EMPTY = 'rounded-2xl border border-dashed border-slate-200 p-10 text-center text-sm text-slate-600 dark:border-slate-700';
